import { IonIcon } from '@ionic/react';
import clsx from 'clsx';
import { earthOutline } from 'ionicons/icons';
import React from 'react';
import { casinoIdListEnum } from 'common/commonEnum';
import { PreviewCasinoBadge } from 'components/PreviewCasinoBadge/PreviewCasinoBadge';

interface CasinoCardProps {
  logoIcon: string;
  name: string;
  address: string;
  website: string;
  actionText: string;
  onActionClick: () => void;
  isComingSoon?: boolean;
  /** Server flag: Coming Soon casino unlocked for preview group members. */
  isPreview?: boolean;
  isPlayerLinked?: boolean;
  hasAccess?: boolean;
  timeLeft?: number;
  proCasinoSubscription?: boolean;
  casinoId?: number;
  isSelected?: boolean;
  // e.g. "3.2 mi" — shown next to the address once the user shares location.
  distanceLabel?: string;
  isNearest?: boolean;
}

export const casinoBgMap: Partial<Record<casinoIdListEnum, string>> = {
  [casinoIdListEnum.LOTC]: 'assets/images/header-lotc-bg.png',
  [casinoIdListEnum.JJC]:  'assets/images/header-lotc-bg.png',
  [casinoIdListEnum.RWC]:  'assets/images/header-rwc-bg.png',
  [casinoIdListEnum.SSC]:  'assets/images/header-ssc-bg.png',
  [casinoIdListEnum.ACH]:  'assets/images/header-rwc-bg.png',
};

export const CasinoCard: React.FC<CasinoCardProps> = ({
  isPlayerLinked = false,
  isComingSoon = false,
  isPreview = false,
  hasAccess = false,
  timeLeft = 0,
  proCasinoSubscription = false,
  isSelected = false,
  isNearest = false,
  distanceLabel,
  name,
  address,
  website,
  logoIcon,
  actionText,
  onActionClick,
  casinoId
}) => {
  const rightBgImage = casinoId !== undefined ? casinoBgMap[casinoId as casinoIdListEnum] : undefined;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.open(website, '_blank');
  };

  const onActionClickHandler = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    onActionClick();
  };

  const formatTimeLeft = (remainingTime: number | null): string => {
    if (remainingTime === null) {
      return '';
    }
    return '';
  };

  return (
    <div className={clsx('casino-card', { 'casino-card--pro': isSelected && proCasinoSubscription })}>
      <div className="casino-logo" onClick={onActionClickHandler}>
        <img src={logoIcon} />
      </div>

      <div
        className="card-info"
        style={rightBgImage ? { backgroundImage: `url(/${rightBgImage})`, backgroundSize: 'cover', backgroundPosition: 'center right', backgroundRepeat: 'no-repeat' } : undefined}
      >
        <div className="casino-info">
          <div onClick={onActionClickHandler} className='casino-block'>
            <h3 className="caption-text heading">
              {casinoId === casinoIdListEnum.ACH && name.includes(' & Casino')
                ? <>{name.replace(' & Casino', '')}<br />& Casino</>
                : name}
              {isPreview ? <PreviewCasinoBadge /> : null}
            </h3>
            <p className="remove-margins location body-small">{address}</p>
            {distanceLabel && (
              <p
                className={clsx('remove-margins casino-distance body-tiny', {
                  'casino-distance--nearest': isNearest,
                })}
                data-testid="casino-distance"
              >
                {isNearest ? `Nearest to you · ${distanceLabel}` : distanceLabel}
              </p>
            )}
          </div>

          <a
            onClick={handleClick}
            target="_blank"
            rel="noreferrer"
            className="link-website body-small"
          >
            <IonIcon className="icon" icon={earthOutline} />
            Website
          </a>
        </div>

        {/* Coming Soon stays in Upcoming launches; preview members still get select/play. */}
        {isComingSoon && !isPreview ? (
          <></>
        ) : (
          <div className="action">
            {isSelected ? (
              <></>
            ) : (
              <>
                <div className="link">
                  <span
                    onClick={onActionClickHandler}
                    className="body-small-bold action action-link"
                    data-testid="casinoCardAction"
                  >
                    {actionText}
                    {/* <IonIcon className="icon" icon={chevronForward} /> */}
                  </span>
                </div>
                {!isPlayerLinked && (
                  <div
                    className={clsx('body-tiny', 'info-text', {
                      warning: hasAccess,
                    })}
                  >
                    {formatTimeLeft(timeLeft)}
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
